import { render, staticRenderFns } from "./UploadInvoices.vue?vue&type=template&id=185e678e&scoped=true&"
import script from "./UploadInvoices.vue?vue&type=script&lang=js&"
export * from "./UploadInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e678e",
  null
  
)

export default component.exports